import React from "react";
import Meta from "../components/global/meta";
import { Button } from "@speedoc/design-assets";
import { GlobalStore } from "../stores/global";

const Four0Four = () => {
  const countryCode = GlobalStore.useState(s => s.currentCountryCode);

  return (
    <div id="four0Four" className="centralContainer">
      <Meta four0Four={true} seo={{ index: false, description: "Page not found" }} title={"404 - Page not found"} />
      <div className="container">
        <div className="polyline" />
        <div className="content">
          <div className="title">
            Uh oh...
            <br />
            We have a problem.
          </div>
          <div className="description">Error 404 - Page not found</div>
          <div className="ctaContainer">
            <div className="text">Let’s get you a doctor!</div>
            <div className="ctaBox">
              <a href={`/${countryCode.toLowerCase()}`}>
                <Button className="primary sm">
                  <span>Back to Home</span>
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Four0Four;
